const levels = [
  {
    level: 'A1',
    label: 'A1 – Beginner',
    cards: [
      {
        title: 'Introductions',
        image: '/Images/2people1.webp',
        level: 'A1',
        desc: 'Introduce yourself and ask about others in first conversations.',
        links: [
          { text: 'Introductions', to: '/grammar-exercises/introductions', level: 'A1' },
        ],
      },
      {
        title: 'To Be: Am, Is, Are',
        image: '/Images/1person1.webp',
        level: 'A1',
        desc: "Practice drills",
        links: [
          { text: 'To Be: Am, Is, Are', to: '/grammar-exercises/to-be-present', level: 'A1' },
        ],
      },
      {
        title: 'Simple Present',
        image: '/Images/1person2.webp',
        level: 'A1',
        desc: 'Routine actions, habits, and general truths.',
        links: [
          { text: 'Simple Present', to: '/grammar-exercises/simple-present', level: 'A1' },
        ],
      },
      {
        title: 'Present Continuous',
        image: '/Images/1person3.webp',
        level: 'A1',
        desc: 'Actions happening right now',
        links: [
          { text: 'Present Continuous', to: '/grammar-exercises/present-continuous', level: 'A1' },
        ],
      },
      {
        title: 'To Be: Was, Were',
        image: '/Images/tobe-past1.webp',
        level: 'A1',
        desc: "Past form of 'to be'",
        links: [
          { text: 'To Be: Was, Were', to: '/grammar-exercises/to-be-past', level: 'A1' },
        ],
      },
      {
        title: 'Some and Any/Countable Uncountable ',
        image: '/Images/tobe-past1.webp',
        level: 'A1',
        desc: "Countable Uncountable",
        links: [
          { text: 'To Be: Was, Were', to: '/grammar-exercises/some-any', level: 'A1' },
        ],
      },
      {
        title: 'There is / There are',
        image: '/Images/1person1.webp',
        level: 'A1',
        desc: 'Say that something exists or talk about where things are.',
        links: [
          { text: 'There is / There are', to: '/grammar-exercises/there-is-there-are', level: 'A1' },
        ],
      }
    ],
      
  },

  {
    level: 'A2',
    label: 'A2 – Elementary',
    cards: [
      {
        title: 'Simple Present vs. Present Continuous',
        image: '/Images/simppres1.webp',
        level: 'A2',
        desc: 'When to use',
        links: [
          {
            text: 'Simple Present vs. Present Continuous',
            to: '/grammar-exercises/simpcont',
            level: 'A2',
          },
        ],
      },
      {
        title: 'Simple Past',
        image: '/Images/simplepast1.webp',
        level: 'A2',
        desc: 'Completed actions in the past',
        links: [
          { text: 'Simple Past', to: '/grammar-exercises/simple-past', level: 'A2' },
        ],
      },
      {
        title: 'Past Continuous',
        image: '/Images/pastcont1.webp',
        level: 'A2',
        desc: 'Ongoing actions in the past',
        links: [
          { text: 'Past Continuous', to: '/grammar-exercises/past-continuous', level: 'A2' },
        ],
      },
      {
        title: 'Future',
        image: '/Images/future1.webp',
        level: 'A2',
        desc: "'will' and 'going to'.",
        links: [
          { text: 'Future', to: '/grammar-exercises/future', level: 'A2' },
        ],
      },
      {
        title: 'Zero Conditional',
        image: '/Images/zerocond1.webp',
        level: 'A2',
        desc: 'If to state facts',
        links: [
          { text: 'Zero Conditional', to: '/grammar-exercises/zero-conditional', level: 'A2' },
        ],
      },
      {
        title: '1st Conditional',
        image: '/Images/firstcond1.webp',
        level: 'A2',
        desc: 'Talk about real and possible situations in the present or future using the first conditional.',
        links: [
          { text: '1st Conditional', to: '/grammar-exercises/first-conditional', level: 'A2' },
          { text: '1st Conditional (Prod)', to: '/grammar-exercises/first-cond-prod', level: 'A2' },
        ],
      },
      {
        title: 'Can',
        image: '/Images/modals1.webp',
        level: 'A2',
        desc: 'Use common modal verbs to express ability, permission, possibility, advice, and necessity.',
        links: [
          { text: 'Modals', to: '/grammar-exercises/can', level: 'A2' },
        ],
      },
      {
        title: 'Comparison',
        image: '/Images/comparison1.webp',
        level: 'A2',
        desc: 'Compare people, places, and things using comparative and superlative forms.',
        links: [
          { text: 'Comparison', to: '/grammar-exercises/comparison-a2', level: 'A2' },
        ],
      }
    ],
  },

  {
    level: 'B1',
    label: 'B1 – Intermediate',
    cards: [
      {
        title: 'Present Perfect',
        image: '/Images/presperf.webp',
        level: 'B1',
        desc: 'Connect past actions and experiences to the present with the present perfect.',
        links: [
          { text: 'Present Perfect', to: '/grammar-exercises/present-perfect', level: 'B1' },
        ],
      },
      {
        title: 'Present Perfect vs. Simple Past',
        image: '/Images/havedone1.webp',
        level: 'B1',
        desc: 'Distinguish between completed past events and experiences connected to the present.',
        links: [
          { text: 'Present Perfect vs. Simple Past', to: '/grammar-exercises/perfect-past', level: 'B1' },
        ],
      },
      {
        title: '2nd Conditional',
        image: '/Images/secondcond1.webp',
        level: 'B1',
        desc: 'Talk about hypothetical, unlikely, or imaginary situations in the present or future.',
        links: [
          { text: '2nd Conditional', to: '/grammar-exercises/second-conditional', level: 'B1' },
        ],
      },
      {
        title: 'Indirect Speech',
        image: '/Images/reported1.webp',
        level: 'B1',
        desc: 'Report what someone said without repeating their exact words.',
        links: [
          { text: 'Indirect Speech', to: '/grammar-exercises/indirect-speech', level: 'B1' },
        ],
      },
      {
        title: 'Passive',
        image: '/Images/passive1.webp',
        level: 'B1',
        desc: 'Use the passive voice to focus on an action or its result rather than the person who performs it.',
        links: [
          { text: 'Passive', to: '/grammar-exercises/passive', level: 'B1' },
        ],
      },
      {
        title: 'Used to',
        image: '/Images/usedto.webp',
        level: 'B1',
        desc: 'Talk about past habits and states that are no longer true.',
        links: [
          { text: 'Used to', to: '/grammar-exercises/usedto', level: 'B1' },
        ],
      },
      {
        title: 'Gerunds',
        image: '/Images/gerunds1.webp',
        level: 'B1',
        desc: 'Use verbs followed by -ing forms with common patterns such as enjoy, avoid, and suggest.',
        links: [
          { text: 'Gerunds', to: '/grammar-exercises/gerunds', level: 'B1' },
        ],
      },
      {
        title: 'Infinitives',
        image: '/Images/infinitives1.webp',
        level: 'B1',
        desc: 'Use common verb patterns with to + infinitive, including decide, hope, plan, and want.',
        links: [
          { text: 'Infinitives', to: '/grammar-exercises/infinitives', level: 'B1' },
        ],
      },
      {
        title: 'Adjectives and Adverbs',
        image: '/Images/adjadv.webp',
        level: 'B1',
        desc: 'Use adjectives and adverbs accurately to describe people, actions, and situations.',
        links: [
          { text: 'Adjectives and Adverbs', to: '/grammar-exercises/adjadv', level: 'B1' },
        ],
      },
      {
        title: 'Past Habits',
        image: '/Images/habits1.webp',
        level: 'B1',
        desc: 'Describe repeated actions and habits in the past using would, used to, and past simple.',
        links: [
          { text: 'Past Habits', to: '/grammar-exercises/pasthabits', level: 'B1' },
        ],
      },
      {
        title: 'So and Enough',
        image: '/Images/enough1.webp',
        level: 'B1',
        desc: "Express degree and sufficiency using 'so', 'such', 'enough', and 'too'.",
        links: [
          { text: 'So and Enough', to: '/grammar-exercises/soenough', level: 'B1' },
        ],
      },
      {
        title: 'Cause and Effect',
        image: '/Images/causeandeffect1.webp',
        level: 'B1',
        desc: 'Express reasons and results using common cause-and-effect structures.',
        links: [
          { text: 'Cause and Effect', to: '/grammar-exercises/causeeffect', level: 'B1' },
        ],
      },
      {
        title: 'Relative Clauses',
        image: '/Images/grammar.webp',
        level: 'B1',
        desc: 'Combine information using relative clauses with who, which, that, whose, where, and when.',
        links: [
          { text: 'Relative Clauses', to: '/grammar-exercises/relativeclauses', level: 'B1' },
        ],
      },
      {
        title: 'Comparison',
        image: '/Images/comparison1.webp',
        level: 'B1',
        desc: 'Compare people and things using comparative and superlative structures.',
        links: [
          { text: 'Comparison', to: '/grammar-exercises/comparison', level: 'B1' },
        ],
      },
      {
        title: 'Linking Words',
        image: '/Images/linkingwords1.webp',
        level: 'B1',
        desc: 'Connect ideas clearly using common conjunctions and linking expressions.',
        links: [
          { text: 'Linking Words', to: '/grammar-exercises/linking-words', level: 'B1' },
        ],
      },
      {
        title: 'Punctuation',
        image: '/Images/writing1-1280x470.webp',
        level: 'B1',
        desc: 'Use common punctuation marks accurately in written English.',
        links: [
          { text: 'Punctuation', to: '/grammar-exercises/punctuation', level: 'B1' },
        ],
      },
      {
        title: 'Ed or Ing',
        image: '/Images/eding1.webp',
        level: 'B1',
        desc: 'Distinguish between -ed and -ing adjectives such as bored and boring.',
        links: [
          { text: 'Ed or Ing', to: '/grammar-exercises/ed-ing', level: 'B1' },
        ],
      },
      {
        title: 'Gerunds and Infinitives',
        image: '/Images/gerunds1.webp',
        level: 'B1',
        desc: 'Choose between -ing forms and to + infinitive, including verbs where the meaning changes.',
        links: [
          { text: 'Gerunds and Infinitives', to: '/grammar-exercises/gerunds-infinitives', level: 'B1' },
        ],
      },
      {
        title: 'Suggest, Recommend, Offer, Promise',
        image: '/Images/advice.webp',
        level: 'B1',
        desc: 'Give advice, make offers and commit to actions with common verb patterns.',
        links: [
          { text: 'Suggest, Recommend, Offer, Promise', to: '/grammar-exercises/suggest', level: 'B1' },
        ],
      },
      {
        title: 'Tense Review',
        image: '/Images/grammar1.webp',
        level: 'B1',
        desc: 'Review the main tenses from present simple to future perfect, plus conditionals.',
        links: [
          { text: 'Tense Review', to: '/grammar-exercises/tense-review', level: 'B1' },
        ],
      },
      {
        title: 'Sense Verbs',
        image: '/Images/sense1.webp',
        level: 'B1',
        desc: 'Use common sense verbs such as see, hear, feel, and watch with the correct verb patterns.',
        links: [
          { text: 'Sense Verbs', to: '/grammar-exercises/sense-verbs', level: 'B1' },
        ],
      },
      {
        title: 'Must / Have to / Need to / Should',
        image: '/Images/must-have-to.webp',
        level: 'B1',
        desc: 'Express obligation, necessity, prohibition, and advice with modal and semi-modal verbs.',
        links: [
          { text: 'Must / Have to / Need to / Should', to: '/grammar-exercises/must-have-to', level: 'B1' },
        ],
      },
    ],
  },

  {
    level: 'B2',
    label: 'B2 – Upper-Intermediate',
    cards: [
      {
        title: '3rd Conditional',
        image: '/Images/thirdcond1.webp',
        level: 'B2',
        desc: 'Talk about unreal situations in the past and their imagined results.',
        links: [
          { text: '3rd Conditional', to: '/grammar-exercises/third-conditional', level: 'B2' },
        ],
      },
      {
        title: 'Mixed Conditionals',
        image: '/Images/mixedcond1.webp',
        level: 'B2',
        desc: 'Combine different time references within conditional sentences.',
        links: [
          { text: 'Mixed Conditionals (prod)', to: '/grammar-exercises/mixed-cond-prod', level: 'B2' },
        ],
      },
      {
        title: 'Modals Deduction',
        image: '/Images/deduction1.webp',
        level: 'B2',
        desc: 'Make logical deductions about present and past situations using modal verbs.',
        links: [
          { text: 'Modals Deduction', to: '/grammar-exercises/modals-deduction', level: 'B2' },
        ],
      },
      {
        title: 'Reported Speech',
        image: '/Images/reportedspeech1.webp',
        level: 'B2',
        desc: 'Report statements, questions, and other speech with appropriate tense and reference changes.',
        links: [
          { text: 'Reported Speech', to: '/grammar-exercises/reported-speech', level: 'B2' },
        ],
      },
      {
        title: 'Passive being',
        image: '/Images/Passivebeing1.webp',
        level: 'B2',
        desc: 'Use more advanced passive structures with continuous and perfect aspects.',
        links: [
          { text: 'Passive being', to: '/grammar-exercises/passivebeing', level: 'B2' },
        ],
      },
      {
        title: 'Unless',
        image: '/Images/unless1.webp',
        level: 'B2',
        desc: "Use 'unless' and related conditional structures to express exceptions and conditions.",
        links: [
          { text: 'Unless', to: '/grammar-exercises/unless', level: 'B2' },
        ],
      },
      {
        title: 'Wishes and Regrets',
        image: '/Images/wish1.webp',
        level: 'B2',
        desc: 'Express wishes, regrets, and unreal situations involving the present, past, and future.',
        links: [
          { text: 'Wishes and Regrets', to: '/grammar-exercises/wish', level: 'B2' },
        ],
      },
      {
        title: 'Word Forms',
        image: '/Images/wordforms1.webp',
        level: 'B2',
        desc: 'Use related noun, verb, adjective, and adverb forms accurately in context.',
        links: [
          { text: 'Word Forms', to: '/grammar-exercises/word-forms', level: 'B2' },
        ],
      },
      {
        title: 'Dependent Prepositions',
        image: '/Images/dependentpreps1.webp',
        level: 'B2',
        desc: 'Use the correct prepositions after common verbs, adjectives, and nouns.',
        links: [
          { text: 'Dependent Prepositions', to: '/grammar-exercises/dependent-prepositions', level: 'B2' },
        ],
      },
      {
        title: 'Collocations',
        image: '/Images/collocations1.webp',
        level: 'B2',
        desc: 'Use common and less predictable word combinations naturally and accurately.',
        links: [
          { text: 'Collocations', to: '/grammar-exercises/collocations', level: 'B2' },
        ],
      },
      {
        title: 'Passive with Get',
        image: '/Images/passive1.webp',
        level: 'B2',
        desc: 'Use get instead of be to form the passive in everyday English.',
        links: [
          { text: 'Passive with Get', to: '/grammar-exercises/passive-get', level: 'B2' },
        ],
      },
      {
        title: 'Passive Reporting Verbs',
        image: '/Images/reportedspeech1.webp',
        level: 'B2',
        desc: 'Report general beliefs and expectations with passive reporting verbs and be supposed to.',
        links: [
          { text: 'Passive Reporting Verbs', to: '/grammar-exercises/passive-reporting', level: 'B2' },
        ],
      },
      {
        title: 'Descriptive Adjectives',
        image: '/Images/adverbadjective1.webp',
        level: 'B2',
        desc: 'Describe character traits in detail with -ive, -able, -ous and compound adjectives.',
        links: [
          { text: 'Descriptive Adjectives', to: '/grammar-exercises/descriptive-adjectives', level: 'B2' },
        ],
      },
      {
        title: 'Device Verbs',
        image: '/Images/computerprogramming.webp',
        level: 'B2',
        desc: 'Describe what machines and devices do with verbs like convert, emit and transmit.',
        links: [
          { text: 'Device Verbs', to: '/grammar-exercises/device-verbs', level: 'B2' },
        ],
      },
      {
        title: 'Money Idioms',
        image: '/Images/idioms1.webp',
        level: 'B2',
        desc: 'Understand everyday expressions about money, spending and saving.',
        links: [
          { text: 'Money Idioms', to: '/grammar-exercises/money-idioms', level: 'B2' },
        ],
      },
      {
        title: 'Using the Verb Provide',
        image: '/Images/techpeople1.webp',
        level: 'B2',
        desc: 'Use provide in technical English with its common patterns and collocations.',
        links: [
          { text: 'Using the Verb Provide', to: '/grammar-exercises/provide-verb', level: 'B2' },
        ],
      },
    ],
  },

  {
    level: 'C1',
    label: 'C1 – Advanced',
    cards: [],
  },
];


// Transform to flat array with ActivityFilter fields
const levelNameMap = {
  'A1': 'A1 – Beginner',
  'A2': 'A2 – Elementary',
  'B1': 'B1 – Intermediate',
  'B2': 'B2 – Upper-Intermediate',
  'C1': 'C1 – Advanced'
};

function slugify(str) {
  return str.toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 60);
}



function extractSubtitle(desc) {
  // Get first sentence or first clause
  const firstSentence = desc.split('.')[0];
  const firstClause = firstSentence.split(',')[0];
  return firstClause.length > 80 ? firstClause.slice(0, 80) + '...' : firstClause;
}

const grammarExercisesData = levels.flatMap(({ level, label, cards }) =>
  cards.map((card, i) => ({
    id: `grammar-${slugify(card.title)}`,
    title: card.title,
    subtitle: extractSubtitle(card.desc),
    category: 'grammar-exercises',
    theme: 'Grammar',
    level,
    levelname: label,
    description: card.desc,
    image: card.image,
    links: card.links
  }))
);

export default grammarExercisesData;
